import React from 'react';
import { tabChange } from '../uiFunctions/uiActions';

class ClientAssignmentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    isAssigned(clientCode, clientList) {
		var checked = false;
		if (clientList.includes(clientCode)) {
			checked = true;
		}
		return checked;
	}

    render() {
        const group = this.props.group;
        const params = this.props.params;
        var clients = this.props.clients;
        const widget = this.props.widget;
        const assign = this.props.assign;

        return(
            <React.Fragment>
                <h4>Clients Participating</h4>
                <div className={group+"-tabs-wrapper tabs-wrapper"}>
                    <div id={group+"-tabs"} className="tabs">
                        {params.map((param, index) =>
                            <div id={"tab-"+index}
                                key={index}
                                className={"tab "+group+"-"+index}
                                onClick={() => tabChange(group, index)} >
                                    {param.label}
                            </div>
                        )}
                    </div>
                </div>
                <div id={group+"-inputs"} className={group+"-inputs tab-inputs"}>
                    {params.map((param, index) =>
                        <div id={group+"-"+index} className={"tab "+group+"-"+index} key={index}>
                            <ul className="promo-clientList">
                                {clients && (
                                    clients.map(client => (client[param.key] === param.value) &&
                                        ( <React.Fragment key={client.clientCode}>
                                            <li>
                                                <input type="checkbox" id={widget.type+"-"+client.clientCode} onChange={() => assign(client.clientCode, widget.clientCodes, widget)} checked={this.isAssigned(client.clientCode, widget.clientCodes)} />
                                                <span>{client.name}</span>
                                                {(param.key === "velocity" && param.value === true) && (
                                                    <div>
                                                        <p><em>Package: {(client.servicePackage) ? ( client.servicePackage ):( "N/A" )} </em></p>
                                                        <p><em>Colorwall: {((client.options.colorWall) && (client.options.colorWall === "1")) ? ( "Enabled" ):( "No" )}</em></p>
                                                    </div>
                                                )}
                                            </li>
                                        </React.Fragment> )
                                    )
                                )}
                            </ul>
                        </div>
                    )}
                </div>
            </React.Fragment>
        )
    }
}
export default ClientAssignmentList;


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/ClientAssignmentList.js